import Loader from 'components/Loader';
import UploadMedia from 'containers/others/Media/uploadMedia';
import useRequest from 'hooks/useRequest';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  Button,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { MODULE_TYPE, SOURCE } from 'utils/constants';
import { handleSaveAsset } from 'utils/helper';

const UpdateSchoolDocuments = ({ schoolId, isOpen, toggle, selectedDocument, handleChangePage }) => {
  toast.configure();

  const documentTypes = [
    { label: 'School Brochure', value: 'school_brochure' },
    { label: 'Admission Brochure', value: 'admission_brochure' },
    { label: 'Fee Details', value: 'fee_document' },
    { label: 'Video', value: 'school_video' },
  ];

  const currentYear = new Date().getFullYear();

  const defaultValues = {
    title: '',
    description: '',
    academicYear: currentYear,
    type: '',
    url: '',
    document: null,
    isDocumentUpload: false,
  };

  const [document, setDocument] = useState(defaultValues);

  const academicYearsOptions = [
    { label: currentYear - 1, value: currentYear - 1 },
    { label: currentYear, value: currentYear },
    { label: currentYear + 1, value: currentYear + 1 },
  ];

  const [addSchoolDocument, { loading }] = useRequest({
    url: '/school/admin/marketing-document',
    method: 'POST',
    onSuccess: () => {
      toggle();
      setDocument(defaultValues);
      toast.success('Success! Document has been added.');
      // Close modal after saving
      handleChangePage(1);
    },
    onError: (err) => toast.error(err?.message?.message || err?.message),
  });
  const [updateSchoolDocument, { loading: updateSchoolDocumetLoading }] = useRequest({
    method: 'PUT',
    onSuccess: () => {
      toggle();
      setDocument(defaultValues);

      toast.success('Success! Document has been updated.');
      // Close modal after saving
      handleChangePage(1);
    },
    onError: (err) => toast.error(err?.message?.message || err?.message),
  });

  const handleChange = (key, value) => {
    setDocument((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = async () => {
    if (!document.type || !document.title || !document.academicYear) {
      toast.error('Please fill in all required fields.');
      return;
    }

    const payload = {
      ...document,
      schoolId,
      ...(document?.document?.id
        ? { documentId: document?.document?.id || -1, url: '' }
        : !isEmpty(selectedDocument)
        ? { documentId: -1 }
        : {}),
      document: undefined,
      isDocumentUpload: undefined,
    };

    if (selectedDocument) {
      await updateSchoolDocument({
        url: `/school/admin/marketing-document/${selectedDocument?.id}`,
        body: payload,
      });
    } else {
      await addSchoolDocument({
        body: payload,
      });
    }
  };

  useEffect(() => {
    if (!isEmpty(selectedDocument)) {
      setDocument({
        title: selectedDocument?.title,
        description: selectedDocument?.description,
        academicYear: selectedDocument?.academicYear,
        type: selectedDocument?.type,
        url: selectedDocument?.url,
        document: selectedDocument?.document,
        isDocumentUpload: !isEmpty(selectedDocument?.document),
      });
    }
  }, [selectedDocument]);

  return (
    <div>
      <Loader isActive={loading || updateSchoolDocumetLoading} />

      <Modal
        size="lg"
        centered
        isOpen={isOpen}
        toggle={() => {
          toggle();
          setDocument(defaultValues);
        }}>
        <ModalHeader
          toggle={() => {
            toggle();
            setDocument(defaultValues);
          }}>
          {selectedDocument ? 'Update' : 'Add'} School Document
        </ModalHeader>
        <ModalBody className="p-4">
          <Row>
            <Col md={6}>
              <FormGroup className="mb-4">
                <Label>
                  Document Type <span className="text-danger">*</span>
                </Label>
                <Select
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  placeholder="Please select type"
                  options={documentTypes}
                  value={documentTypes.find((t) => t.value === document.type)}
                  onChange={({ value }) => handleChange('type', value)}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup className="mb-4">
                <Label>
                  Academic Year <span className="text-danger">*</span>
                </Label>
                <Select
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  placeholder="Please select academic year"
                  options={academicYearsOptions}
                  value={academicYearsOptions.find((t) => t.value === document.academicYear)}
                  onChange={({ value }) => handleChange('academicYear', value)}
                />
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup className="mb-4">
                <Label>
                  Title <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  placeholder="Enter Title..."
                  value={document.title}
                  onChange={(e) => handleChange('title', e.target.value)}
                />
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup className="mb-4">
                <Label>Description</Label>
                <Input
                  type="textarea"
                  rows={3}
                  placeholder="Enter Description..."
                  value={document.description}
                  onChange={(e) => handleChange('description', e.target.value)}
                />
              </FormGroup>
            </Col>

            <Col md={12}>
              <CardTitle>Is Document Upload</CardTitle>
              <div>
                {[true, false].map((option) => (
                  <div key={`isDocumentUpload_${option}`} className="form-check d-inline-block me-4">
                    <input
                      type="radio"
                      id={`isDocumentUpload_${option}`}
                      name="isDocumentUpload"
                      className="form-check-input"
                      checked={document.isDocumentUpload === option}
                      onChange={() => {
                        if (!isEmpty(selectedDocument)) {
                          if (!option && document?.document?.id) {
                            const isConfirm = confirm('This document is already uploaded. Do you want to remove it?');
                            if (isConfirm) {
                              handleChange('document', null);
                            } else {
                              return;
                            }
                          }
                        }

                        handleChange('isDocumentUpload', option);
                      }}
                    />
                    <label htmlFor={`isDocumentUpload_${option}`} className="form-check-label">
                      {option ? 'Yes' : 'No'}
                    </label>
                  </div>
                ))}
              </div>
            </Col>

            {document.isDocumentUpload ? (
              <Col md={12} className="mt-3">
                <UploadMedia
                  isFormik={false}
                  allowFormats={{
                    'video/mp4': ['.mp4'],
                    'application/pdf': ['.pdf'],
                  }}
                  defaultValues={{
                    isAsset: true,
                    renameOriginal: false,
                    renameOriginalRaw: false,
                    backgroundDetails: { width: 500, height: 500, minPadding: 20, backgroundColor: '#ffffff' },
                  }}
                  uploadedImagePreview={document.document}
                  setUploadedImagePreview={async (value) => {
                    const savedFile = await handleSaveAsset(value, MODULE_TYPE.SCHOOL);
                    handleChange('document', savedFile);
                  }}
                  source={SOURCE[0]?.value}
                />
              </Col>
            ) : (
              <Col md={12} className="mt-3">
                <FormGroup className="mb-4">
                  <Label>URL</Label>
                  <Input
                    type="text"
                    placeholder="Enter URL..."
                    value={document.url}
                    onChange={(e) => handleChange('url', e.target.value)}
                  />
                </FormGroup>
              </Col>
            )}
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button className="me-3" color="primary" onClick={handleSave}>
            Save
          </Button>
          <Button
            color="light"
            onClick={() => {
              toggle();
              setDocument(defaultValues);
            }}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default UpdateSchoolDocuments;
